import { cookie, write, retrieveAndParse } from '../utilities/Utility';
import moment from 'moment-timezone';
import { actions as mainActions } from '../config/reduxIndex';
import { writePrecursorXMLSingle } from '../writes/udo';

export const types = {
	SET_DEFAULT: 'NOTES/SET_DEFAULT',
	SET_STATE: 'NOTES/SET_STATE',
	ADD_NEW: 'NOTE/ADD_NEW',
	REMOVE_NOTE_STATE_ONLY: 'NOTE/REMOVE_NOTE_STATE_ONLY',
	MODIFY_NOTE_STATE: 'NOTE/MODIFY_NOTE_STATE'
}

const notesDefault = {
	'notesList': [],
	'uniqueID': null,
	'type': null,
	'isLoading': true,
	parentType: null,
	parentKey: null,
	parentSubType: null,
	parentSubKey: null
}

export default (state = notesDefault, action) => {
	let newList = [];
	switch(action.type) {
		case types.SET_DEFAULT:
			return Object.assign({}, notesDefault);
		case types.ADD_NEW:
			return Object.assign({}, state, {
				'notesList': [...state.notesList, newNote(state)]
			});
		case types.REMOVE_NOTE_STATE_ONLY:
			newList = state.notesList.slice(0);
			newList.splice(action.noteIndex, 1);
			return Object.assign({}, state, {
				'notesList': newList
			});
		case types.MODIFY_NOTE_STATE:
			newList = state.notesList.map((noteObj, i) => {
				if(i === action.noteIndex) {
					return Object.assign({}, noteObj, action.newNote);
				}
				return noteObj
			});
			return Object.assign({}, state, {
				'notesList': newList
			});
		case types.SET_STATE:
			return Object.assign({}, state, action.newState);
		default:
			return state;
	}
}

const newNote = (obj) => {
	return {
		note: '',
		noteType: 'issue',
		key: null,
		parentType: obj.type,
		parentKey: obj.uniqueID,
		parentSubType: obj.subType,
		parentSubKey: obj.subTypeKey,
		active: 'Y',
		type: 'note',
		isLoading: false
	}
}

export const actions = {
	setDefault: () => ({type: types.SET_DEFAULT}),
	closeNotesOverlay: () => {
		return (dispatch) => {
			dispatch(mainActions.globalState.closeOverlay());
			dispatch(actions.setDefault());
		}
	},
	addNewNote: (parentType, parentKey) => ({type: types.ADD_NEW, parentType, parentKey}),
	saveNote: (noteObj) => {
		return function(dispatch, getState) {
			const currentState = getState().notes;
			const currentNotes = currentState.notesList;
			const currentUser = cookie.get('currentUser');
			const currentNoteState = currentNotes[noteObj['noteIndex']];
			const currentMoment = moment();
			const noteWriteObj = Object.assign({}, currentNoteState, {
				'note': noteObj['currentText'],
				'noteType': noteObj['currentNoteType'],
				'updatedBy': currentUser,
				'updateDate': currentMoment.format('YYYY-MM-DD'),
				'updateTime': parseFloat(currentMoment.format('HHmm'))
			});
			dispatch(actions.modifyNoteState(noteObj.noteIndex, noteWriteObj));
			const hasNotes = {
				hasNotes: true
			}
			dispatch(mainActions.scheduleElements.setScheduleElementParams(currentState.type, currentState.uniqueID, hasNotes))
			const writeRequest = writeNote(noteWriteObj);
			writeRequest.then((res) => {
				const key = res.Data.Results[0].Key;
				const newNote = {
					key
				}
				dispatch(actions.modifyNoteState(noteObj.noteIndex, newNote));
			});
		}
	},
	setState: (newState) => ({type: types.SET_STATE, newState}),
	openAndRetrieve: (obj) => {
		return function(dispatch) {
			dispatch(mainActions.globalState.openOverlay('notes'));
			const uniqueID = obj.uniqueID;
			const stateObj = {
				parentType: obj.type,
				parentKey: obj.uniqueID,
				parentSubType: obj.subType,
				parentSubKey: obj.subTypeKey,
				isLoading: true
			}
			dispatch(actions.setState(stateObj));
			const params = {uniqueID};
			const readRequest = retrieveAndParse('Notes.GetNotesByUniqueID', params);
			readRequest.then((notesList) => {
				dispatch(actions.setState({
					notesList,
					isLoading: false
				}))
			})
		};
	},
	modifyNoteState: (noteIndex, newNote) => {
		return {
			type: types.MODIFY_NOTE_STATE,
			noteIndex,
			newNote
		}
	},
	removeNoteStateOnly: (noteIndex) => {
		return ({
			type: types.REMOVE_NOTE_STATE_ONLY,
			noteIndex
		})
	},
	removeNote: (noteObj) => {
		return function(dispatch, getState) {
			writeNote(noteObj);
			dispatch(actions.removeNoteStateOnly(noteObj.noteIndex));
			const notes = getState().notes;
			if(notes.notesList.length === 0) {
				const { uniqueID, type } = notes;
				const noNotes = {
					hasNotes: false
				}
				dispatch(mainActions.scheduleElements.setScheduleElementParams(type, uniqueID, noNotes));
			}
		}
	}
}

const writeNote = (noteWriteObj) => {
	const obj = writePrecursorXMLSingle(noteWriteObj);
	return write(obj);
}



// WEBPACK FOOTER //
// ./src/redux/notes.js